module.exports = __webpack_public_path__ + "img/49.927d5cd1.jpg";